<template>
  <div class="cn-popup-wrapper" v-if="!loading" v-on:click="$event.target.className==='cn-popup-wrapper' ? $emit('closeOverlay') :''">
    <!-- Navigations -->
    <span class="cn-pop-left-arrow" v-on:click="loadPrevious()">
      <i class="cn-icon-arrow-circle-left"></i>
    </span>
    <span class="cn-pop-right-arrow" v-on:click="loadNext()">
      <i class="cn-icon-arrow-circle-right"></i>
    </span>

    <!-- Close Button -->
    <span class="cn-pop-close-btn" v-on:click="$emit('closeOverlay')">
      <i class="cn-icon-close"></i>
    </span>

    <!--::TODO Img will be media-->
    <div
      :class="['cn-popup-inner-wrap',media ? '' : 'cn-pop-noimg',]"
      v-on:touchstart="handleGesture($event,'start')"
      v-on:touchmove="handleGesture($event,'move')"
    >
      <div class="cn-popup-inner-sub-wrapper" v-if="!itemData.tweet_is_video">
        <!--Share Popup-->
        <div class="cn-share-popup" style="display:flex;" v-if="displaySharePopup">
          <ul>
            <li>
              <a class="cn-no-underline" rel="nofollow" v-on:click="shareItem" data-type="twitter" :href="'https://twitter.com/intent/tweet?text='+itemData.url" target="_blank">
                <i class="cn-icon-twitter"></i>
              </a>
            </li>
            <li>
              <a class="cn-no-underline" rel="nofollow"
                v-on:click="shareItem" data-type="facebook"
                :href="'https://www.facebook.com/sharer/sharer.php?u='+itemData.url"
                target="_blank"
              >
                <i class="cn-icon-facebook"></i>
              </a>
            </li>
            <li>
              <a class="cn-no-underline" rel="nofollow"
                v-on:click="shareItem" data-type="linkedin"
                :href="'https://www.linkedin.com/shareArticle?mini=true&url='+itemData.url"
                target="_blank"
              >
                <i class="cn-icon-linkedin"></i>
              </a>
            </li>
            <li>
              <a class="cn-no-underline" rel="nofollow"
                v-on:click="shareItem" data-type="pinterest"
                :href="'https://pinterest.com/pin/create/button/?url='+itemData.url"
                target="_blank"
              >
                <i class="cn-icon-pinterest"></i>
              </a>
            </li>
            <li>
              <a class="cn-no-underline" rel="nofollow" :href="'mailto:info@example.com?&subject=&body='+itemData.url" target="_blank">
                <i class="cn-icon-envelope"></i>
              </a>
            </li>
          </ul>
          <span class="cn-share-close" v-on:click="displaySharePopup=false">
            <i class="cn-icon-close"></i>
          </span>
        </div>

        <!-- Media Section-->
        <!-- Image -->
        <div class="cn-popup-img" v-if="itemData.type === 'image' || mediaType === 'image' || itemData.type === 'photo' || mediaType === 'photo'">
          <img :src="media.replace(/http:|https:/i, '')" alt v-if="media" v-on:error="mediaError" />
        </div>
        <!-- Video -->
        <div class="cn-popup-img" v-if="itemData.type === 'video' || mediaType === 'video' || mediaType === 'embed'">
          <div class="cn-youtube-overlay" v-if="itemData.service === 'youtube'" v-html="itemData.media[0].embed"></div>
          <video width="320" height="240" autoplay controls v-if="media && itemData.service !== 'youtube'">
            <source :src="media.replace(/http:|https:/i, '')" type="video/mp4" v-on:error="mediaError">
          </video>
        </div>

        <!--Content-->
        <div class="cn-popup-body">
          <div class="cn-pop-header">
            <div class="cn-pop-header-left">
              <a class="cn-no-underline" rel="nofollow" :href="getAuthorURL()" target="_blank">
                <img :src="itemData.author.image" v-if="itemData.author.image" v-on:error="itemData.author.image = null" alt />
                <i v-else class="cn-icon-user-circle" style="font-size:30px; color:#212529 !important"></i>
              </a>
            </div>
            <div class="cn-pop-header-cen">
              <h3>
                <a rel="nofollow" :href="getAuthorURL()" target="_blank">{{itemData.author.name || itemData.author.username}}</a>
              </h3>
              <span>{{date}}</span>
            </div>
            <div class="cn-pop-header-right">
              <a class="cn-no-underline" rel="nofollow" :href="itemData.url" target="_blank">
                <i :class="['cn-icon-'+((itemData.service === 'oembed') ? 'rss' : itemData.service)]" aria-hidden="true"></i>
              </a>
            </div>
          </div>
          <div class="cn-popup-con">
            <h1 class="cn-post-pop-title" v-if="itemData.title">{{itemData.title}}</h1>
            <p v-html="itemData.text"></p>
          </div>
          <div class="cn-pop-footer">
            <div class="cn-pop-footer-left">
              <div class="cn-post-footer-left" v-if="itemData.service === 'oembed' || itemData.service === 'rss' ">
                <a rel="nofollow" :href="itemData.url" target="_blank">Read more</a>
              </div>
            </div>
            <div class="cn-pop-footer-right">
              <!--For twitter these options show-->
              <ul class="cn-social-links" v-if="0">
                <li>
                  <a rel="nofollow"
                    :href="'https://twitter.com/intent/tweet?in_reply_to='+itemData.id"
                    title="Reply"
                    target="_blank"
                  >
                    <i class="fa fa-reply"></i>
                  </a>
                </li>
                <li>
                  <a rel="nofollow"
                    :href="'https://twitter.com/intent/retweet?tweet_id='+itemData.id"
                    title="Retweet"
                    target="_blank"
                  >
                    <i class="fa fa-retweet"></i>
                  </a>
                </li>
                <li>
                  <a rel="nofollow"
                    :href="'https://twitter.com/intent/like?tweet_id='+itemData.id"
                    title="Like"
                    target="_blank"
                  >
                    <i class="fa fa-heart"></i>
                  </a>
                </li>
              </ul>
              <ul class="cn-social-links">
                <li>
                  <a class="cn-no-underline" rel="nofollow" href="javascript:void(0)" v-on:click="displaySharePopup=true">
                    <i class="cn-icon-share-alt"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div :class="['cn-tweetpost']" v-if="itemData.service === 'twitter' && itemData.tweet_is_video">
        <tweet-view :id="itemData.id" v-if="!destroytweet" :options="{}">
          <div class="cn-tw-spinner">
            <svg width="200" heigth="200" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
              <path fill="#ccc" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
              <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform>
              </path>
            </svg>
          </div>
        </tweet-view>
      </div>
    </div>
  </div>
</template>

<script>
import { Tweet } from 'vue-tweet-embed'
export default {
  name: 'itemOverlay',
  props: ['items', 'itemId'],
  components: {
    'tweet-view': Tweet
  },
  data () {
    return {
      media: '',
      mediaType: '',
      date: '',
      itemData: '',
      loading: true,
      destroytweet: false,
      displaySharePopup: false,
      showfullTweet: false,
      touch: {
        xDown: null,
        yDown: null
      }
    }
  },
  created () {
    this.itemData = this.items.find(i => i.id === this.itemId)
  },
  mounted () {
    if (this.itemData) {
      this.initData()
      this.loading = false
    }
  },
  methods: {
    initData () {
      if (this.itemData.service === 'youtube') {
        this.media = 'embed'
      } else {
        this.media = this.itemData.media ? this.itemData.media[0].url.includes('/emoji/') ? '' : this.itemData.media[0].url : ''
        this.mediaType = this.itemData.media ? this.itemData.media[0].type : ''
        this.mediaType = this.itemData.service === 'instagram' || this.itemData.service === 'facebook' || this.itemData.service === 'twitter' ? 'photo' : this.mediaType
      }
      var date = new Date(this.itemData.date)
      var month = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ]
      this.date =
        date.getDate() +
        ' ' +
        month[date.getMonth() - 1] +
        ' ' +
        date.getFullYear()
      if (this.itemData.service === 'rss' || this.itemData.service === 'oembed') {
        this.itemData.author.image = this.getFavicon(this.getBaseURL(this.itemData.url))
      }
      if (this.itemData.service === 'twitter' && this.media.includes('amplify_video_thumb')) {
        this.itemData.tweet_is_video = true
      } else {
        this.itemData.tweet_is_video = false
      }
    },
    getAuthorURL () {
      if (this.itemData.author !== 'undefined') {
        var link = ((this.itemData.service === 'twitter' || this.itemData.service === 'instagram' || this.itemData.service === 'youtube') ? this.itemData.author.url : '//' + this.itemData.service + '.com/' + this.itemData.author.userid)
        if (this.itemData.service === 'rss' || this.itemData.service === 'oembed') {
          link = this.itemData.url
        }
        return link
      }
      return ''
    },
    loadPrevious () {
      this.destroytweet = true
      this.$emit('moveOverlay', 'left')
      this.loading = true
      this.displaySharePopup = false
      var index = this.items.findIndex(i => i.id === this.itemData.id)
      if (this.items.length > 1 && index > 0) {
        this.itemData = this.items[index - 1]
        this.initData()
      }
      this.loading = false
      this.showfullTweet = false
      setTimeout(() => {
        this.destroytweet = false
      }, 1000)
    },
    loadNext () {
      this.destroytweet = true
      this.$emit('moveOverlay', 'right')
      this.loading = true
      this.displaySharePopup = false
      // Current  Loaded Item Index
      var index = this.items.findIndex(i => i.id === this.itemData.id)
      if (this.items.length > 1 && index + 1 < this.items.length) {
        this.itemData = this.items[index + 1]
        this.initData()
      }
      this.loading = false
      this.showfullTweet = false
      setTimeout(() => {
        this.destroytweet = false
      }, 1000)
    },
    handleGesture (e, type) {
      if (type === 'start') {
        this.touch.xDown = e.touches[0].clientX
        this.touch.yDown = e.touches[0].clientY
      }
      if (type === 'move') {
        if (!this.touch.xDown || !this.touch.yDown) {
          return
        }

        var xUp = e.touches[0].clientX
        var yUp = e.touches[0].clientY

        var xDiff = this.touch.xDown - xUp
        var yDiff = this.touch.yDown - yUp

        if (Math.abs(xDiff) > Math.abs(yDiff)) {
          /* most significant */
          if (xDiff > 0) {
            this.loadNext()
          } else {
            this.loadPrevious()
          }
        } else {
          if (yDiff > 0) {
            /* up swipe */
          } else {
            /* down swipe */
          }
        }
        /* reset values */
        this.touch.xDown = null
        this.touch.yDown = null
      }
    },
    mediaError () {
      this.media = false
    },
    getBaseURL (url) {
      var a = document.createElement('a')
      a.href = url
      return 'https://' + a.hostname
    },
    shareItem (e) {
      if (typeof e !== 'undefined') {
        this.$emit('shareItem', e.currentTarget.getAttribute('data-type'))
        console.log(e.currentTarget.getAttribute('data-type'))
      }
    }
  }
}
</script>
